import { formatJsonDataset as fjd } from "../../components/renderers";

export const activityconfig = {

  activity: {
    service: {
      name: 'activity',
      title: 'Activities',
      num: true,
      fields: [
        'rid','nam','shc','ati','atn','atc','api','apn','apc','cci','ccn','ccc','dsc','exi','sts','ast','stp'
      ],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Type'],
        ['apn','Parent'],
        ['ccn','Cost Center'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Type', v:'atn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activitytype' } },
        { id:'api', label:'Parent Activity', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  driver: {
    service: {
      name: 'driver',
      title: 'Drivers',
      num: true,
      fields: ['rid','nam','shc','umi','umn','umc','dsc','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['umn','UOM'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'umi', label:'UOM', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: {}
  },

  activitycost: {
    service: {
      name: 'activitycost',
      title: 'Activity Costs',
      num: true,
      fields: [
        'rid','aci','acn','acc','lii','lin','lic','rvi','rvn','rvc','rii','rin','ric',
        'amt','alr','dsc','exi','sts','ast','stp'
      ],
      grid: [
        ['acn','Activity'],
        ['lin','Line Item'],
        ['rvn','Review'],
        ['rin','Requisition Item'],
        ['amt','Amount'],
        ['alr','Allocation Ratio'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Activity', v:'acn' },
          { t:'Line Item', v:'lin' },
          { t:'Requisition Item', v:'rin' }
        ],
        def:'acn'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'lii', label:'Line Item', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'rvi', label:'Review', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'itemreview' } },
        { id:'rii', label:'Requisition Item', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'requisitionitem' } },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'alr', label:'Allocation Ratio', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  activitydriver: {
    service: {
      name: 'activitydriver',
      title: 'Activity Drivers',
      num: true,
      fields: ['rid','aci','acn','acc','dri','drn','drc','fml','dfv','dsc','exi','sts','ast','stp'],
      grid: [
        ['acn','Activity'],
        ['drn','Driver'],
        ['fml','Formula'],
        ['dfv','Default Value'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Activity', v:'acn' },
          { t:'Driver', v:'drn' }
        ],
        def:'acn'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'dri', label:'Driver', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'driver' } },
        { id:'fml', label:'Formula', type:'ta', req:0, ops:{} },
        { id:'dfv', label:'Default Value', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  activityplan: {
    service: {
      name: 'activityplan',
      title: 'Activity Plans',
      num: true,
      fields: ['rid','aci','acn','acc','bpi','bpn','bpc','bci','bcn','bcc','drv','tgv','pam','dsc','exi','sts','ast','stp'],
      grid: [
        ['acn','Activity'],
        ['bpn','Period'],
        ['bcn','Cycle'],
        ['drv','Driver Value'],
        ['tgv','Target Value'],
        ['pam','Planned Amount'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Activity', v:'acn' },
          { t:'Period', v:'bpn' }
        ],
        def:'acn'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'bci', label:'Cycle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetcycle' } },
        { id:'drv', label:'Driver Value', type:'nf', req:0, ops:{} },
        { id:'tgv', label:'Target Value', type:'nf', req:0, ops:{} },
        { id:'pam', label:'Planned Amount', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  activityoutput: {
    service: {
      name: 'activityoutput',
      title: 'Activity Outputs',
      num: true,
      fields: ['rid','aci','acn','acc','nam','shc','umi','umn','umc','dsc','exi','sts','ast','stp'],
      grid: [
        ['acn','Activity'],
        ['nam','Name'],
        ['shc','Code'],
        ['umn','UOM'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Activity', v:'acn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'umi', label:'UOM', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  activitybudgetlink: {
    service: {
      name: 'activitybudgetlink',
      title: 'Activity Budget Links',
      num: true,
      fields: ['rid','aci','acn','acc','lii','lin','lic','alr','ala','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['acn','Activity'],
        ['lin','Line Item'],
        ['alr','Allocation Ratio'],
        ['ala','Allocated Amount'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Activity', v:'acn' },
          { t:'Line Item', v:'lin' }
        ],
        def:'acn'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'lii', label:'Line Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'alr', label:'Allocation Ratio', type:'nf', req:0, ops:{} },
        { id:'ala', label:'Allocated Amount', type:'nf', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  activityperformance: {
    service: {
      name: 'activityperformance',
      title: 'Activity Performance',
      num: true,
      fields: ['rid','api','apn','apc','pdt','phr','fir','aam','com','evi','rsi','rsn','rsc','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['apn','Activity Plan'],
        ['pdt','Date'],
        ['phr','Physical Rate'],
        ['fir','Financial Rate'],
        ['aam','Actual Amount'],
        ['rsn','State'],
        ['com','Commentary'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Activity Plan', v:'apn' },
          { t:'Date', v:'pdt' }
        ],
        def:'apn'
      },
      eform: [
        { id:'api', label:'Activity Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activityplan' } },
        { id:'pdt', label:'Performance Date', type:'df', req:1, ops:{} },
        { id:'phr', label:'Physical Rate', type:'nf', req:0, ops:{} },
        { id:'fir', label:'Financial Rate', type:'nf', req:0, ops:{} },
        { id:'aam', label:'Actual Amount', type:'nf', req:0, ops:{} },
        { id:'com', label:'Commentary', type:'ta', req:0, ops:{} },
        { id:'evi', label:'Evidence Info', type:'jf', req:0, ops:{} },
        { id:'rsi', label:'State', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'reviewstate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd, evi:fjd } }
  },

};